import Account from "../models/Account";

/// Get route to account view for given account
export const getAccountRoute = (account?: Account|{type: string, id: number}): string|null => {
  let route: string|null = null;
  if (account.type == Account.types.COMPANY) {
    route = `/companies/${account.id}`;
  } else if (account.type == Account.types.REAL_ESTATE) {
    route = `/real_estates/${account.id}`;
  } else if (account.type == Account.types.PRIVATE) {
    route = `/accounts/${account.id}`;
  }
  return route;
}